import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

// Dummy reducer to satisfy combineReducers
const initialState = {};
function reducer(state = initialState, _action = {}) {
  return state;
}

export default reducer;

export const loadData = (params, _search) => dispatch => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent));
};
